import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useMemo, forwardRef } from 'react';
import cn from 'classnames';
import createStyles from "../createStyles";
export var useStyles = createStyles({
  root: {
    minWidth: function minWidth(props) {
      return props.width;
    },
    minHeight: function minHeight(props) {
      return props.height;
    }
  },
  fillInherit: {
    fill: 'currentColor'
  },
  fill: {
    fill: function fill(_ref) {
      var fillColor = _ref.fillColor;
      return fillColor || 'currentColor';
    }
  },
  stroke: {
    stroke: function stroke(_ref2) {
      var strokeColor = _ref2.strokeColor;
      return strokeColor || 'initial';
    }
  }
}, {
  name: 'Icon'
});
var Icon = /*#__PURE__*/forwardRef(function Icon(_ref3, ref) {
  var _cn;

  var _ref3$fillColor = _ref3.fillColor,
      fillColor = _ref3$fillColor === void 0 ? '' : _ref3$fillColor,
      _ref3$strokeColor = _ref3.strokeColor,
      strokeColor = _ref3$strokeColor === void 0 ? '' : _ref3$strokeColor,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 20 : _ref3$width,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? 20 : _ref3$height,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      jss = _ref3.jss,
      svg = _ref3.svg;
  var classes = useStyles({
    width: width,
    height: height,
    fillColor: fillColor,
    strokeColor: strokeColor,
    jss: jss
  });
  var Svg = useMemo(function () {
    return svg;
  }, [svg]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(Svg, {
      ref: ref,
      width: width,
      height: height,
      style: style,
      className: cn(classes.root, (_cn = {}, _defineProperty(_cn, classes.fillInherit, !fillColor), _defineProperty(_cn, classes.fill, fillColor), _defineProperty(_cn, classes.stroke, strokeColor), _cn), className)
    })
  );
});
Icon.displayName = 'Icon';
export default Icon;